import React from "react";
import {Box, Card, CardContent, Chip, Divider, Skeleton, Stack, Typography} from "@mui/material";
import {Link as RouterLink} from "react-router-dom";
import UpgradeNotice from "../../shared/UpgradeNotice";
import Sparkline from "./Sparkline";

export default function DashboardCashflowCard({
    loading,
    hasAccounting,
    last6,
    cashflowSeries,
    incomeSeries,
    expenseSeries,
    fmtEUR,
}) {
    if (!hasAccounting) {
        return (
            <UpgradeNotice
                fullHeight
                title="Cashflow-Analysen freischalten"
                description="Die Cashflow-Übersicht ist Teil des 20 € netto Buchhaltungstarifs."
                actionLabel="Buchhaltung aktivieren"
            />
        );
    }

    return (
        <Card sx={{borderRadius: 3, height: "100%", boxShadow: "0 6px 24px rgba(0,0,0,0.06)"}}>
            <CardContent>
                <Stack direction="row" justifyContent="space-between" alignItems="center">
                    <Box>
                        <Typography variant="h6">Cashflow – letzte 6 Monate</Typography>
                        <Typography variant="body2" color="text.secondary" sx={{mb: 1}}>
                            Einnahmen – Ausgaben je Monat
                        </Typography>
                    </Box>
                </Stack>
                {loading ? (
                    <Skeleton variant="rectangular" height={80} sx={{borderRadius: 2}}/>
                ) : (
                    <Box sx={{display: "flex", alignItems: "center", gap: 2, color: "text.primary"}}>
                        <Stack alignItems="center">
                            <Typography variant="caption">Einnahmen</Typography>
                            <Sparkline data={incomeSeries}/>
                        </Stack>
                        <Stack alignItems="center">
                            <Typography variant="caption">Ausgaben</Typography>
                            <Sparkline data={expenseSeries}/>
                        </Stack>
                        <Stack alignItems="center">
                            <Typography variant="caption">Saldo</Typography>
                            <Sparkline data={cashflowSeries}/>
                        </Stack>
                    </Box>
                )}
                <Divider sx={{my: 1.5}}/>
                <Stack direction="row" gap={1} flexWrap="wrap">
                    {last6.map((key, idx) => (
                        <Chip
                            key={key}
                            label={`${key}: ${fmtEUR(cashflowSeries[idx] || 0)}`}
                            size="small"
                            variant="outlined"
                        />
                    ))}
                    <Chip component={RouterLink} to="/cashflow" label="Liquiditätsprognose" clickable color="primary"/>
                </Stack>
            </CardContent>
        </Card>
    );
}
